import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import Img from '../../../../../../components/Img';
import { EventAttachmentMediaTypes } from '../../../../../../utils/eventConstants';

import styles from './attachments.scss';

const AttachmentItem = ({ attachment, index, isDraggable, onClickAttachment, onDeleteAttachment }) => (
    <Draggable
        draggableId={attachment.fileId}
        index={index}
        isDragDisabled={!isDraggable}
    >
        {(dragProvided, snapshot) => (
            <div
                ref={dragProvided.innerRef}
                {...dragProvided.draggableProps}
                className={`col-12 mb16 ${snapshot.isDragging ? styles.dragging : ''}`}
            >
                <div
                    {...dragProvided.dragHandleProps}
                    className={`${styles.attachmentRow} ${isDraggable ? styles.draggableRow : ''}`}
                >
                    {isDraggable && <span data-test="grip-dots" className={styles.gripDots} />}
                    <div className={styles.icon}>
                        <Img src={'/img/v3/icons/icon-note.svg'} />
                    </div>
                    <span
                        data-test={`attachment-${attachment.fileId}`}
                        className="link clickable"
                        onClick={() => onClickAttachment(attachment)}
                    >
                        {attachment.attachmentMediaType === EventAttachmentMediaTypes.LINK ? 'View' : 'Download'} {attachment.title}
                    </span>
                    {attachment.actions?.delete?.allowed && onDeleteAttachment && (
                        <span
                            data-test={`attachment-${attachment.fileId}-delete`}
                            className={styles.deleteButton}
                            onClick={() => onDeleteAttachment(attachment)}
                        >
                            <Img src={'/img/v3/icons/icon-trash-red.svg'} />
                        </span>
                    )}
                </div>
            </div>
        )}
    </Draggable>
);

AttachmentItem.propTypes = {
    attachment: PropTypes.shape({
        fileId: PropTypes.string.isRequired,
        title: PropTypes.string,
        srcUrl: PropTypes.string,
        attachmentMediaType: PropTypes.string,
        actions: PropTypes.shape({
            delete: PropTypes.shape({
                allowed: PropTypes.bool,
            }),
        }),
    }).isRequired,
    index: PropTypes.number.isRequired,
    isDraggable: PropTypes.bool,
    onClickAttachment: PropTypes.func.isRequired,
    onDeleteAttachment: PropTypes.func,
};

AttachmentItem.defaultProps = {
    isDraggable: false,
    onDeleteAttachment: null,
};

export default AttachmentItem;
